import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  WPEvaluationMaster,
} from "../../models/serverModels/permission/WPEvaluationMaster";

import {
  EvaluationListParams, WPDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";

const rootApi = process.env.REACT_APP_API_KEY;

const permission = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: EvaluationListParams
): Promise<ResponseList<WPEvaluationMaster>> =>
  permission({
    url: "/GetEvaluationMasterList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<WPEvaluationMaster>> =>
  permission({
    url: `/EvaluationMaster/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<WPEvaluationMaster>
): Promise<ResponseItem<WPEvaluationMaster>> =>
  permission({
    url: `/EvaluationMaster`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  permission({
    url: `/EvaluationMaster/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WPEvaluationMaster>
): Promise<ResponseItem<WPEvaluationMaster>> =>
  permission({
    url: `/EvaluationMaster/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const getCreate = async (
  params: Params.GetItem
): Promise<ResponseItem<WPEvaluationMaster>> =>
  permission({
    url: `/NewEvaluationMaster`,
    method: "get",
    params,
  }).then((res) => res.data);

export const getCreateRevision = async (
  params: Params.GetItem
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/NewEvaluationRevision`,
    method: "get",
    params,
  }).then((res) => res.data);

export const copy = async (
  params: Params.Copy
): Promise<ResponseItem<WPEvaluationMaster>> =>
  permission({
    url: `/CopyDangerEvaluation`,
    method: "post",
    data: params,
  }).then((res) => res.data);